var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"chat-box cm-shell"},[_c('b-row',[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"12","lg":"10"}},[_c('MaterialApplicationStep',{staticClass:"mb-4",style:({
          '--main-color': _vm.mainColor,
          '--secondary-color': _vm.secondaryColor,
          '--product-deep': '#3e175e',
          '--product-rgb': '145, 74, 207',
          '--product-soft': '#f7f0fc',
          '--product-line': '#e3d4f0',
        }),attrs:{"context":_vm.context,"initial-mode":"class-material","class-material-only":true},on:{"go-to-step":_vm.noop,"no-uses":_vm.noop}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }